import config from "@dataroom/config";

export const SECTOR_INDUSTRY_TOOLTIP = 'Sector or Industry';
export const PENDING_REQUESTS_TOOLTIP = 'Pending Requests';
export const COUNT_LABEL_BACKGROUND_COLOR = '#cc4d4d';

export const getApprovedColumnTooltip = (tenant: string) => `Indicates if you are pre-approved to access
  an ${ config[tenant as keyof typeof config].options.tenantLabel }`;
export const getApprovedCellTooltip = (tenant: string) => `You are pre-approved to access
  this ${ config[tenant as keyof typeof config].options.tenantLabel }`;
